import React, { Component } from 'react';
import { Button, Grid, Paper, TextField } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import "./Styles/Body.css"

class SearchBar extends Component {

    state = {
        searchTerm: "",
    }

    handleChange = (event) => this.setState({ searchTerm: event.target.value });

    handleSubmit = (event) => {
        const { searchTerm } = this.state;
        const { onFormSubmit } = this.props;

        onFormSubmit(searchTerm);
        event.preventDefault();
    }

    render() {
        return (
                <div>
                    <form onSubmit={this.handleSubmit} className='search_form'>
                        <InputBase
                            placeholder="Search"
                            size="small"
                            inputProps={{ 'aria-label': 'search google maps' }}
                            onChange={this.handleChange}
                            className="search_field"
                        />
                        <Button type="submit"  className='search_btn' aria-label="search">
                            <SearchIcon />
                        </Button>
                    </form>
                </div>
        )
    }
}
export default SearchBar